'use client';

import {CourseGuidancePopupEntryPoint} from '@udemy-v2/react-globalization-components';
import {useIsClient} from '@/lib/use-is-client';

export function EntryPointPopUp() {
    const isClient = useIsClient();

    if (!isClient) return null;

    return <CourseGuidancePopupEntryPoint />;
}
